module.exports = __webpack_public_path__ + "img/logo_board_light.1861db41.svg";